import {
  IconButton,
  IconButtonProps,
  InputAdornment,
  InputAdornmentProps,
} from "@mui/material";
import { FC, MouseEvent, PropsWithChildren } from "react";

interface IAdornmentButtonProps extends PropsWithChildren {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  position?: InputAdornmentProps["position"];
  size?: IconButtonProps["size"];
  buttonProps?: Omit<IconButtonProps, "onClick" | "size" | "onMouseDown">;
  hidden?: InputAdornmentProps["hidden"];
}

export const AdornmentButton: FC<IAdornmentButtonProps> = ({
  onClick,
  position = "start",
  size = "small",
  children,
  buttonProps,
  hidden = false,
}) => {
  const onMouseDown = (event: MouseEvent<HTMLButtonElement>): void =>
    event.preventDefault();

  const onClickHandler = (event: MouseEvent<HTMLButtonElement>): void => {
    onClick?.(event);
  };

  return (
    <InputAdornment
      position={position}
      sx={{
        visibility: hidden ? "hidden" : "visible",
      }}
    >
      <IconButton
        size={size}
        onClick={onClickHandler}
        onMouseDown={onMouseDown}
        edge={position}
        {...buttonProps}
      >
        {children}
      </IconButton>
    </InputAdornment>
  );
};
